<div class="card-single-one" (click)="openCheklistModal(serviceOrderCard)">
  <div>
    <div style="display: flex; gap: 8px; align-items: center;">
      <div class="id-os">{{ serviceOrderCard.orderServiceId }}</div>
      <div>{{ serviceOrderCard.nome }}</div>
    </div>
    <div style="display: flex; gap: 15px; align-items: center; margin-top: 8px;">
      <div>{{ serviceOrderCard.data_agendamento | date: 'dd/MM/yyyy' }}</div>
      <div *ngIf="serviceOrderCard.serviceType == 'Manutenção'" style="display: flex; gap: 8px; align-items: center;">
        <div class="icon" style="background-color: #121e6f;">
          <mat-icon style="font-size: 18px;">construction</mat-icon>
        </div>
      </div>

      <div *ngIf="serviceOrderCard.serviceType == 'Retirada'" style="display: flex; gap: 8px; align-items: center;">
        <div class="icon" style="background-color: #51ade0;">
          <mat-icon style="font-size: 18px;">undo</mat-icon>
        </div>
      </div>

      <div *ngIf="serviceOrderCard.serviceType == 'Instalação'" style="display: flex; gap: 8px; align-items: center;">
        <div class="icon" style="background-color: #175ca9;">
          <mat-icon style="font-size: 18px;">build</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; flex-direction: column-reverse; align-items: center; gap: 8px;">
    <div 
      ngbDropdown 
      #statusDrop="ngbDropdown" 
      class="statusDrop" 
      container="body"
      (click)="$event.stopPropagation()">

      <fa-icon
        size="1x"
        type="button"
        class="btn-icon"
        [icon]="faSettings" 
        ngbDropdownToggle
      ></fa-icon>

      <div ngbDropdownMenu class="dropdown-status">
        <div 
          *ngFor="let status of statusList" 
          class="drop-down-item"
          (click)="handleStatusChange(status.id)"
          [ngClass]="{'active-status': serviceOrderCard.status === status.id}"
          ngbDropdownItem>
          <fa-icon [icon]="status.icon"></fa-icon> {{status.label}}
        </div>
      </div>
    </div>

    <div 
      ngbDropdown 
      class="dropdown-card-service-order"
      (click)="$event.stopPropagation()"
      container="body">
      
      <fa-icon
        size="1x"
        type="button"
        class="btn-icon"
        [icon]="faEllipsis"
        id="acoes-service-order"
        ngbDropdownToggle
      ></fa-icon>
      
      <div
        ngbDropdownMenu
        aria-labelledby="acoes-service-order"
        class="custom-dropdown-menu">
        
        <div
          ngbDropdownItem
          (click)="handleEditServiceOrder(serviceOrderCard)" class="drop-down-item">
          <fa-icon [icon]="faEdit"></fa-icon> Editar
        </div>

        <div
          ngbDropdownItem
          (click)="handleDeleteServiceOrder(serviceOrderCard.id)" class="drop-down-item">
          <fa-icon [icon]="faDelete"></fa-icon> Deletar
        </div>

        <div
          ngbDropdownItem
          (click)="handleShareLink(serviceOrderCard.id)" class="drop-down-item">
          <fa-icon [icon]="shareBtn"></fa-icon> Compartilhar
        </div>
      </div>
    </div>
  </div>
</div>